import {isIntercomAvailable} from './is-intercom-available';

export const shutdownIntercom = () => {
    if (!isIntercomAvailable()) {
        return false;
    }

    window.Intercom('shutdown');
    return true;
};
